module.exports = __webpack_public_path__ + "static/media/projectImage.20468db9.png";